import React, { useState } from 'react';
import { Row, Col, Button, Dropdown, Form } from 'react-bootstrap';
import './ProfessionalInfo.css';
import Swal from 'sweetalert2';

function ACTechnicianFields({ formData, setFormData }) {

    const [skillDropdownOpen, setSkillDropdownOpen] = useState(false);
    const [skillSearch, setSkillSearch] = useState('');

    const updateField = (field, value) => {
        setFormData(prev => ({ ...prev, [field]: value }));
    };

    const toggleArrayField = (field, item, maxLimit = null) => {
        const currentArray = Array.isArray(formData[field]) ? formData[field] : [];
        if (currentArray.includes(item)) {
            updateField(field, currentArray.filter(i => i !== item));
        } else {
            if (maxLimit && currentArray.length >= maxLimit) {
                Swal.fire({
                    icon: 'warning',
                    title: 'Limit Reached',
                    text: `You can select a maximum of ${maxLimit} options.`,
                    confirmButtonColor: '#0d6efd'
                });
                return;
            }
            updateField(field, [...currentArray, item]);
        }
    };

    const acSystemsOptions = [
        "Split AC", "Window AC", "Cassette AC", "Package Unit",
        "Central AC", "Inverter AC", "VRV/VRF AC"
    ];

    const hvacSystemsOptions = [
        "AHU (Air Handling Unit)", "FCU (Fan Coil Unit)", "Chiller System",
        "Cooling Tower", "VRV/VRF System", "Ductable AC", "Heat Pump"
    ];

    const technicalSkillsOptions = [
        "Installation", "Preventive Maintenance", "Breakdown Maintenance",
        "Troubleshooting", "Gas Charging", "Leak Detection", "Duct Installation",
        "Duct Insulation", "Copper Piping", "Brazing",
        "Electrical Panel Wiring", "Thermostat & Control Wiring", "Reading HVAC Drawings"
    ];

    const toolsKnowledgeOptions = [
        "Manifold Gauge", "Vacuum Pump", "Recovery Machine",
        "Leak Detector", "Multimeter", "Clamp Meter", "Flushing Machine"
    ];

    const acSystems = Array.isArray(formData.ac_systems) ? formData.ac_systems : [];
    const hvacSystems = Array.isArray(formData.hvac_systems) ? formData.hvac_systems : [];
    const acTechnicalSkills = Array.isArray(formData.ac_technical_skills) ? formData.ac_technical_skills : [];
    const acToolsKnowledge = Array.isArray(formData.ac_tools_knowledge) ? formData.ac_tools_knowledge : [];

    const filteredSkills = technicalSkillsOptions.filter(s =>
        s.toLowerCase().includes(skillSearch.toLowerCase())
    );

    return (
        <>
            {/* Air Conditioning Systems */}
            <div className="mb-5">
                <h4 className="mb-3 fw-semibold text-dark d-flex align-items-center fields-headingfont">
                    Air Conditioning Systems
                </h4>
                <Row className="g-3 mb-3">
                    {acSystemsOptions.map((option, idx) => (
                        <Col xs={6} sm={6} md={4} key={idx}>
                            <Button
                                variant="light"
                                className={`language-btn jobtype-btn w-100 ${acSystems.includes(option) ? 'selected-button' : ''}`}
                                onClick={() => toggleArrayField('ac_systems', option)}
                            >
                                {option}
                            </Button>
                        </Col>
                    ))}
                </Row>
            </div>

            {/* HVAC Systems */}
            <div className="mb-5">
                <h4 className="mb-3 fw-semibold text-dark d-flex align-items-center fields-headingfont">
                    HVAC Systems
                </h4>
                <Row className="g-3 mb-3">
                    {hvacSystemsOptions.map((option, idx) => (
                        <Col xs={6} sm={6} md={4} key={idx}>
                            <Button
                                variant="light"
                                className={`language-btn jobtype-btn w-100 ${hvacSystems.includes(option) ? 'selected-button' : ''}`}
                                onClick={() => toggleArrayField('hvac_systems', option)}
                            >
                                {option}
                            </Button>
                        </Col>
                    ))}
                </Row>
            </div>

            {/* Technical Skills - Dropdown Max 4 */}
            <div className="mb-5">
                <h4 className="mb-3 fw-semibold text-dark d-flex align-items-center fields-headingfont">
                    Technical Skills
                    <span className="ms-2 text-muted" style={{ fontSize: '14px', fontWeight: 'normal' }}>
                        (Max 4 options)
                    </span>
                </h4>

                <Dropdown
                    show={skillDropdownOpen}
                    onToggle={(open) => setSkillDropdownOpen(open)}
                >
                    <Dropdown.Toggle
                        variant="light"
                        className="language-select w-100 d-flex justify-content-between align-items-center"
                        id="dropdown-ac-technical-skills"
                    >
                        <span style={{ color: acTechnicalSkills.length > 0 ? '#212529' : '#6c757d' }}>
                            {acTechnicalSkills.length > 0
                                ? `Technical Skills (${acTechnicalSkills.length} selected)`
                                : 'Select Technical Skills'
                            }
                        </span>
                    </Dropdown.Toggle>

                    <Dropdown.Menu className="w-100" style={{ overflowY: 'hidden' }}>
                        <div className="px-2 py-1">
                            <Form.Control
                                type="text"
                                placeholder="Search skills..."
                                value={skillSearch}
                                onChange={(e) => setSkillSearch(e.target.value)}
                                onClick={(e) => e.stopPropagation()}
                                className="mb-2"
                                autoFocus
                            />
                        </div>
                        <div style={{ maxHeight: '250px', overflowY: 'auto' }}>
                            {filteredSkills.length > 0 ? (
                                filteredSkills.map((skill) => (
                                    <Dropdown.Item
                                        key={skill}
                                        active={acTechnicalSkills.includes(skill)}
                                        onClick={() => toggleArrayField('ac_technical_skills', skill, 4)}
                                    >
                                        {skill}
                                    </Dropdown.Item>
                                ))
                            ) : (
                                <Dropdown.Item disabled>No matches found</Dropdown.Item>
                            )}
                        </div>
                    </Dropdown.Menu>
                </Dropdown>

                {acTechnicalSkills.length > 0 && (
                    <div className="mt-3 d-flex flex-wrap gap-2">
                        {acTechnicalSkills.map((skill, idx) => (
                            <div key={idx} className="badge bg-primary d-flex align-items-center" style={{ fontSize: '0.85rem' }}>
                                {skill}
                                <button
                                    type="button"
                                    className="btn-close btn-close-white ms-2"
                                    style={{ fontSize: '0.5rem' }}
                                    onClick={() => toggleArrayField('ac_technical_skills', skill)}
                                    aria-label="Remove"
                                />
                            </div>
                        ))}
                    </div>
                )}
            </div>

            {/* Tools & Equipment Knowledge */}
            <div className="mb-5">
                <h4 className="mb-3 fw-semibold text-dark d-flex align-items-center fields-headingfont">
                    Tools & Equipment Knowledge
                </h4>
                <Row className="g-3 mb-4">
                    {toolsKnowledgeOptions.map((tool, idx) => (
                        <Col xs={6} sm={6} md={4} key={idx}>
                            <Button
                                variant="light"
                                className={`language-btn jobtype-btn w-100 ${acToolsKnowledge.includes(tool) ? 'selected-button' : ''}`}
                                onClick={() => toggleArrayField('ac_tools_knowledge', tool)}
                            >
                                {tool}
                            </Button>
                        </Col>
                    ))}
                </Row>
            </div>
        </>
    );
}

export default ACTechnicianFields;
